import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import { getGap } from '@Components/BigBrowse/Model/Classes/GridCard';
import type {
  PlaneSize,
  PlaneTypes,
} from '@Components/BigBrowse/Model/ModelTypes';
import type { ViewData } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import { getCentralIndexes } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/headerFullWidth/helpers/headerFullWidth.helpers';

export function addHeaderGaps(viewData: ViewData): ViewData {
  const { layoutTable } = viewData;

  const numOfColumns = layoutTable!.length;
  const centralIndexes = getCentralIndexes(numOfColumns);

  const gapSize = {
    width: viewData.columnWidth!,
    height: viewData.columnWidth! * 2 + viewData.columnGap!,
  };
  const iterator = pushGap(gapSize);

  // push gaps before central indexes
  layoutTable!.slice(0, centralIndexes[0]).forEach(iterator);

  // push gaps after central indexes
  layoutTable!
    .slice(centralIndexes[centralIndexes.length - 1] + 1) // +1 to skip the gap in column added by 'Hero Image'
    .forEach(iterator);

  return viewData;
}

function pushGap(size: PlaneSize) {
  return (column: GridCard<PlaneTypes>[]) => column.push(getGap(size));
}
